import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

export interface ErrorInfo {
  statusCode: number;
  message: string;
  timestamp: Date;
  actionType?: string;
  details?: any;
}

export const GlobalError = createAction('[Error] Global Error', props<{ error: ErrorInfo }>());

export const HttpError = createAction(
  '[Error] HTTP Error',
  props<{ httpError: HttpErrorResponse; actionType?: string }>(),
);

export const ClearCurrentError = createAction('[Error] Clear Current Error');

export const ClearAllErrors = createAction('[Error] Clear All Errors');

export const DismissError = createAction('[Error] Dismiss Error', props<{ timestamp: Date }>());
